import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DopAuthService } from '../../../../projects/dop-core/src/lib/security/dop-auth.service';
import { map, filter } from 'rxjs/operators';
import { AuthGuardMessageService } from './auth-guard.message.service';
import { environment } from 'src/environments/environment';
import { LoggerService } from 'projects/dop-core/src/lib/logger/logger.service';
import { UserAuthService } from './user-auth.service';
import { MatomoTracker } from '@ngx-matomo/tracker';
import { AppConfigService } from '../app-config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  constructor(
    private dopAuthService: DopAuthService,
    private loggerService: LoggerService,
    private authGuardMessageService: AuthGuardMessageService,
    private userAuthService: UserAuthService,
    private matomoTracker: MatomoTracker,
    private appConfigService: AppConfigService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    if (environment.enableAuthentication) {
      this.loggerService.log('isLogged in? :', this.dopAuthService.isLoggedIn);
      if (!this.dopAuthService.isLoggedIn) {
        // TODO: redirect to login page
        return of(false);
      } else {
        this.userAuthService.getUserDetails();
        return this.authGuardMessageService.userDataLoaded.pipe(filter(x => x === true), map((isLoaded) => {
          const userDetails = this.userAuthService.userDetails;
          if(userDetails.profile.analyticsEnabled && userDetails.profile.policiesAccepted){
            this.matomoTracker.forgetUserOptOut();
            this.matomoTracker.setConsentGiven();
            this.matomoTracker.setCookieConsentGiven();
            this.matomoTracker.trackPageView();
          }
          else {
            this.matomoTracker.setDoNotTrack(true);
            this.matomoTracker.optUserOut();
          }
          if (!userDetails.profile.hasGuidedOrderingPermission) {
            // User doesn't have Guided Ordering Permission
            this.sendErrorValue(true);
            return false;
          } else if (!userDetails.profile.policiesAccepted) {
            // Redirect user to EOL Website if Policies not accepted
            this.sendErrorValue(true);
            return false;
          } else {
            // Default behavior ie. user need not have specific permission to access page
            this.sendErrorValue(false);
            return true;
          }
        }));
      }
    }
  }

  sendErrorValue(value: boolean) {
    const policiesAccepted = this.userAuthService.getUserDetails().profile.policiesAccepted;
    if(typeof policiesAccepted === 'boolean' && !policiesAccepted){
      this.authGuardMessageService.userDeniedPermission.next(value);
      setTimeout(() => {
        window.location.href = this.appConfigService.EolWebsiteUrl;
      }, 3000);
    }
    else{
    this.authGuardMessageService.userDeniedPermission.next(value);
    }
  }
}
